export const DENY_URLS = [
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  /instagram/i,
  /hotjar/i,
  /googletagmanager/i,
];
